<template>
  <div class="customer-list">
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="customers">
      <el-button slot="toolbar" type="primary" size="mini" @click="$refs.editPage.open(0)">新增</el-button>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="客户名">
            <el-input v-model.trim="filter.name" clearable/>
          </vm-search>
          <vm-search label="联系人">
            <el-input v-model.trim="filter.contactName" clearable/>
          </vm-search>
          <vm-search label="联系电话">
            <el-input v-model.trim="filter.contactPhone" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" type="index" width="50"/>
      <el-table-column prop="name" label="客户姓名"/>
      <el-table-column prop="contactName" label="联系人"/>
      <el-table-column prop="contactPhone" label="联系电话"/>
      <el-table-column prop="source" label="来源" width="175">
        <template slot-scope="scope">
          <el-tag :type="scope.row.source === 'manual' ? 'primary' : 'warning'">
            {{scope.row.createTime}} {{scope.row.source === "new" ? "人工":"导入"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row.id)">编辑</el-button>
          <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <edit-page ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EditPage from "./CustomerEdit.vue";

  export default {
    name: "CustomerList",
    components: {VmTable, VmSearch, EditPage},
    data() {
      return {
        filter: {
          name: "",
          contactName: "",
          contactPhone: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      deleteRow(row) {
        this.$confirm(`确定删除${row.name}吗?`, "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","customers", row.id).then(() => {
            this.getList(-1);
            this.$message.success(row.name + "删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .customer-list {
  }
</style>
